<h2 mat-dialog-title>
  {{ 'epd.functions.careplan-nnn.interventions-section.info-dialog.title' | translate | capitalize }}
</h2>
<mat-dialog-content class="interventions-info">
  <ol class="interventions-info__sections">
    @for (section of sections; track section.key) {
      <li class="interventions-info__section">
        <h3 class="interventions-info__title">
          {{
            'epd.functions.careplan-nnn.interventions-section.info-dialog.' + section.key + '.title'
              | translate
              | capitalize
          }}
        </h3>
        <p class="interventions-info__line">
          <span class="interventions-info__question">
            {{ 'epd.functions.careplan-nnn.interventions-section.info-dialog.what-label' | translate | capitalize }}
          </span>
          {{
            'epd.functions.careplan-nnn.interventions-section.info-dialog.' + section.key + '.what'
              | translate
              | capitalize
          }}
        </p>
        @if (section.hasWhy) {
          <p class="interventions-info__line">
            <span class="interventions-info__question">
              {{ 'epd.functions.careplan-nnn.interventions-section.info-dialog.why-label' | translate | capitalize }}
            </span>
            {{
              'epd.functions.careplan-nnn.interventions-section.info-dialog.' + section.key + '.why'
                | translate
                | capitalize
            }}
          </p>
        }
      </li>
    }
  </ol>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" mat-dialog-close>
    {{ 'general.actions.close' | translate | capitalize }}
  </button>
</mat-dialog-actions>
